
import React from 'react';
import { Card } from '@/components/ui/card';
import { AddPlaceDialog } from './AddPlaceDialog';
import { PlaylistCardHeader } from './playlist-card/PlaylistCardHeader';
import { PlaylistCardContent } from './playlist-card/PlaylistCardContent';
import { PlaylistCardImage } from './playlist-card/PlaylistCardImage';
import { EditPlaylistDialog } from './playlist-card/EditPlaylistDialog';
import { usePlaylistCard } from './playlist-card/usePlaylistCard';

interface PlaylistCardProps {
  id: string;
  name: string;
  description?: string | null;
  placesCount?: number;
  creatorName?: string | null;
  creatorAvatar?: string | null;
  image?: string | null;
  city?: string | null;
  country?: string | null;
  featured?: boolean;
  placeItems?: Array<{
    id: string;
    name: string | null;
    place_type: string | null;
  }>;
}

export function PlaylistCard({
  id,
  name,
  description,
  placesCount = 0,
  creatorName,
  creatorAvatar,
  image,
  city,
  country,
  featured = false,
  placeItems = [],
}: PlaylistCardProps) {
  const {
    isEditDialogOpen,
    setIsEditDialogOpen,
    isAddPlaceDialogOpen,
    setIsAddPlaceDialogOpen,
    editedName,
    setEditedName,
    editedDescription,
    setEditedDescription,
    isPublic,
    setIsPublic,
    playlistData,
    isOwner,
    canEdit,
    isAuthenticated,
    isFollowing,
    followersCount,
    followMutation,
    handleDelete,
    handleUpdate,
    handleCardClick,
    handleAddPlaceClick,
  } = usePlaylistCard({ id, name, description });

  return (
    <>
      <Card 
        className={`hover:shadow-lg transition-shadow cursor-pointer ${featured ? 'border-primary border-2' : ''}`} 
        onClick={handleCardClick}
      >
        <PlaylistCardImage 
          image={image} 
          name={name} 
          isPublic={playlistData?.is_public} 
          featured={featured} 
        />
        
        <PlaylistCardHeader
          name={name}
          description={description}
          city={city}
          isPublic={playlistData?.is_public}
          canEdit={canEdit}
          isOwner={isOwner}
          isAuthenticated={isAuthenticated}
          isFollowing={isFollowing}
          followersCount={followersCount}
          creatorName={creatorName}
          creatorAvatar={creatorAvatar}
          onEdit={() => setIsEditDialogOpen(true)}
          onDelete={handleDelete}
          onFollow={() => followMutation.mutate()}
        />
        
        <PlaylistCardContent
          placeItems={placeItems}
          canEdit={canEdit}
          isAuthenticated={isAuthenticated}
          onAddPlace={handleAddPlaceClick}
        />
      </Card>

      <EditPlaylistDialog
        isOpen={isEditDialogOpen}
        onOpenChange={setIsEditDialogOpen}
        name={editedName}
        description={editedDescription}
        isPublic={isPublic}
        onNameChange={(e) => setEditedName(e.target.value)}
        onDescriptionChange={(e) => setEditedDescription(e.target.value)}
        onIsPublicChange={setIsPublic}
        onSave={handleUpdate}
      />
      
      {canEdit && isAuthenticated && (
        <AddPlaceDialog
          isOpen={isAddPlaceDialogOpen}
          onClose={() => setIsAddPlaceDialogOpen(false)}
          playlistId={id}
        />
      )}
    </>
  );
}
